import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getAllBuilds } from "../../redux-store/testScenarioBuildReducers/testScenarioBuildActions";

import { Box, Grid } from "@mui/material";
import CustomButton from "../Common/CustomButton";
import LoadingOverlay from "../Common/LoadingOverlay";
import BuildCard from "../Common/BuildCard";
import { Visibility } from "@mui/icons-material";

const TestScenarioBuildsDrawer = ({ testScenarioId }) => {
  const dispatch = useDispatch();
  const pageSize = 10;
  const [pageNumber, setPageNumber] = useState(1);
  const [testScenarioBuildList, setTestScenarioBuildList] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const isLoading = useSelector((state) => state.testScenarioBuild.isLoading);
  const [expandedId, setExpandedId] = useState("");
  const isInitial = useRef(true);

  useEffect(() => {
    getTestScenarioBuildList(pageNumber, pageSize);
  }, []);

  const getTestScenarioBuildList = async (pageNumber, pageSize) => {
    const testScenarioBuildResponse = await dispatch(
      getAllBuilds({
        testScenarioId: testScenarioId,
        pageNumber: pageNumber,
        pageSize: pageSize,
      })
    );
    if (testScenarioBuildResponse?.payload) {
      setTestScenarioBuildList((prevState) => [
        ...prevState,
        ...testScenarioBuildResponse.payload?.test_scenario_builds,
      ]);
      setTotalPages(testScenarioBuildResponse.payload?.total_pages);
    }
    isInitial.current = false;
  };

  const onLoadMore = () => {
    setPageNumber((prevState) => prevState + 1);
    getTestScenarioBuildList(pageNumber + 1, pageSize);
  };

  const onExpand = (buildId) => {
    if (buildId === expandedId) {
      setExpandedId("");
    } else {
      setExpandedId(buildId);
    }
  };

  const onViewBuild = (id) => {
    window.open(
      `${window.location.origin}/test-scenario-builds/${id}`,
      "_blank"
    );
  }

  if (isLoading && isInitial.current) {
    return (<LoadingOverlay isLoading={isLoading} sx={{ width: "450px" }} />);
  }

  const renderBuilds = () => {
    return testScenarioBuildList.map((build) => (
      <BuildCard
        key={build.id}
        testScenarioId={testScenarioId}
        build={build}
        isExpanded={expandedId === build.id}
        onExpand={() => {
          onExpand(build.id);
        }}
        onViewBuild={onViewBuild}
        buildType="testScenario"
      />
    ));
  };

  return (
    <Box sx={{
      p: 2, color: "var(--text-primary)",
      backgroundColor: "var(--background-primary)",
    }}>
      <Grid container alignItems="center" sx={{ mb: 2 }}>
        <h4 style={{ marginLeft: "16px" }}>
          All builds({testScenarioBuildList.length})
        </h4>
        <CustomButton
          sx={{ mr: 2, ml: "auto" }}
          variant="outlined"
          color="primary"
          disabled={false}
          onClick={() => {
            window.open(
              `${window.location.origin}/test-scenarios/${testScenarioId}/build/?page=1`,
              "_blank"
            );
          }}
        >
          <Visibility sx={{ mr: 1 }} />
          View all builds
        </CustomButton>
      </Grid>
      {renderBuilds()}
      <div style={{ width: "100%", textAlign: "center" }}>
        {pageNumber < totalPages && !isLoading && (
          <CustomButton sx={{ my: 2 }} onClick={onLoadMore}>
            Load more
          </CustomButton>
        )}
      </div>
    </Box>
  );
};

export default TestScenarioBuildsDrawer;
